import { Box } from "@mui/material";
import { useState } from "react";
import AvatarIcon from "../../../assets/SVG/avatarIcon";
import PhoneIcon2 from "../../../assets/SVG/phoneIcon2";
import CheangPhoneNum from "../../../pages/auth/profile/ChangePhoneNum";
import { LabelInformation } from "./generalInformation";

export default function AcquaintancesInfo({
  nearbyRel,
  nearbyName,
  nearbyPhone,
}) {
  const [openEditPhoneNum, setOpenEditPhoneNum] = useState();

  return (
    <>
      <CheangPhoneNum open={openEditPhoneNum} setOpen={setOpenEditPhoneNum} />

      <Box
        width={"fit-content"}
        minWidth={"400px"}
        maxWidth={"500px"}
        margin="auto"
      >
        <Box display={"flex"} justifyContent="space-between">
          <LabelInformation
            label="نام فرد مذکور"
            value={nearbyName ? nearbyName : "ثبت نشده است "}
          >
            <AvatarIcon />
          </LabelInformation>
          <LabelInformation
            label="نسبت"
            value={nearbyRel ? nearbyRel : "ثبت نشده است"}
          >
            <AvatarIcon />
          </LabelInformation>
        </Box>
        <LabelInformation
          label="تلفن همراه فرد مذکور"
          value={nearbyPhone ? nearbyPhone : "ثبت نشده است"}
        >
          <PhoneIcon2 />
        </LabelInformation>
        <LabelInformation
          sx={{ cursor: "pointer" }}
          value="تغییر تلفن همراه"
          color="#E24B4B"
          onClick={() => setOpenEditPhoneNum(true)}
        >
          <PhoneIcon2 color="#E24B4B" />
        </LabelInformation>
        {/* <Typography color='#8E8E8E' mt='50px' >
        {
          "لطفاً کد زیر را به جهادگران جدیدی که تمایل دارند در اردوهای شما شرکت کنند، ارسال نمایید."
        }
      </Typography>
      <LabelInformation label="کد معرف" value="1283673" >
        <DescriptionIcon/>
      </LabelInformation> */}
      </Box>
    </>
  );
}
